<mat-card #popover
  class="popover mat-elevation-z6">
  @if (step.title) {
    <mat-card-title
      class="title">
      @if (step.icon) {
        <div
          mat-card-avatar
          class="avatar">
          <mat-icon>{{ step.icon }}</mat-icon>
        </div>
      }
      <span class="title">{{ step.title }}</span>
    </mat-card-title>
  }
  <mat-card-content>
    <span class="mat-body">{{ step.text }}</span>
  </mat-card-content>
  <mat-card-actions class="actions">
    @if (lastStep) {
      <button mat-raised-button
        color="primary"
      (click)="ref.close()">{{ 'DIALOG_CLOSE_OPTION' | translate }}</button>
    } @else {
      <button mat-stroked-button
        color="primary"
      (click)="ref.close()">{{ 'DIALOG_CLOSE_OPTION' | translate }}</button>
    }
    @if (!lastStep) {
      <button mat-raised-button
        color="primary"
      (click)="ref.next()">{{ 'DIALOG_NEXT_OPTION' | translate }}</button>
    }
  </mat-card-actions>
</mat-card>
